import { UseMutationOptions, useMutation, useQueryClient } from "@tanstack/react-query";
import { assignPhoneNumber, IAssignPhoneNumberPayload } from "../actions/assign-phone-number.action";
import { EQueryKeys } from "./useMySubscriptionInfo.query";
import { useModals } from "src/context/ModalContext";
import { useGlobalSnackbar } from "src/context/SnackbarContext";
import { SUBSCRIPTION_KEYS } from "../queries/subscription.queries";
import { COMPANY_NUMBERS_KEY } from "@components/virtual-receptionist/widget/components/NumbersConfiguration/query/company-numbers.queries";

export const useAssignPhoneNumberMutation = (options?: UseMutationOptions<any, Error, IAssignPhoneNumberPayload>) => {
  const queryClient = useQueryClient();
  const { closeByKey } = useModals();
  const { showSnackbar } = useGlobalSnackbar();

  return useMutation<any, Error, IAssignPhoneNumberPayload>({
    mutationKey: ["assign-phone-number"],
    mutationFn: assignPhoneNumber,
    onSuccess: async (data, variables, context) => {
      await queryClient.invalidateQueries({
        queryKey: SUBSCRIPTION_KEYS.self("flow_mobile"),
      });

      await queryClient.invalidateQueries({
        queryKey: COMPANY_NUMBERS_KEY,
      });

      closeByKey(`Dashboard-Assign-${variables.subscriptionId}`);
      showSnackbar("Phone number assigned successfully.", "success");

      if (options?.onSuccess) {
        (options.onSuccess as Function)(data, variables, context);
      }
    },
    ...options,
  });
};
